import { Upload, Button } from 'antd'
import {
  // LoadingOutlined, PlusOutlined,
  UploadOutlined
} from '@ant-design/icons'
import { useEffect, useState } from "react"
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage"
import { storage } from "../firebase"
import { showLoader } from '../utils/loader'
import { useStore } from '../contexts/FireStoreContext'

// const defaultFileList = [
//   {
//     uid: '-1',
//     name: 'xxx.png',
//     status: 'done',
//     url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
//     thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
//   },
// ]

const UploadFile = ({ id, table, fieldName, defaultFile, setFile, working }) => {
  const verificationRef = ref(storage, 'verification')

  // Points to 'images'
  const [fileList, setFileList] = useState([])
  const [fileName, setFileName] = useState('')
  const { deleteDocumentField, updateDocumentField } = useStore()

  useEffect(() => {
    if (defaultFile?.name) {
      setFileList([
        {
          uid: '-1',
          name: defaultFile.name,
          status: 'done',
          url: defaultFile.url,
          // thumbUrl: defaultFile,
        }
      ])
    }
  }, [defaultFile])

  // console.log("fileList", fileList)

  // const onPreview = async (file) => {
  //   let src = file.url
  //   if (!src) {
  //     src = await new Promise((resolve) => {
  //       const reader = new FileReader()
  //       reader.readAsDataURL(file.originFileObj)
  //       reader.onload = () => resolve(reader.result)
  //     })
  //   }
  //   const image = new Image()
  //   image.src = src
  //   const imgWindow = window.open(src)
  //   imgWindow.document.write(image.outerHTML)
  // }

  const customRequest = (props) => {
    // console.log("customRequest", props)
    // props.onSuccess()
    working(true)
    // showLoader(true)
    const newFileName = `${new Date().valueOf()}-${props.file.name}`
    setFileName(newFileName)
    // setFileList([{
    //   ...props.file,
    //   name: newFileName
    // }])
    const fileRef = ref(verificationRef, newFileName)
    const uploadTask = uploadBytesResumable(fileRef, props.file)

    // props.onProgress(10)
    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on("state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        props.onProgress(progress)
        // console.log(snapshot)
        // console.log(snapshot.bytesTransferred, snapshot.totalBytes)
        console.log('Upload is ' + progress + '% done')
        // switch (snapshot.state) {
        //   case firebase.storage.TaskState.PAUSED: // or 'paused'
        //     console.log('Upload is paused')
        //     break
        //   case firebase.storage.TaskState.RUNNING: // or 'running'
        //     console.log('Upload is running')
        //     break
        // }
      },
      (error) => {
        // Handle unsuccessful uploads
        props.onError(error)
        console.error(error)
        working(false)
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log('File available at', downloadURL)
          props.onSuccess()
          working(false)
          updateDocumentField(table, fieldName, { name: newFileName, url: downloadURL }, id,
            "File Uploaded Successfully"
          )
          setFile({ name: newFileName, url: downloadURL })
        })
      }
    )
  }

  // const onRemove = (props) => {
  //   console.log("onRemove", props)
  //   working(true)
  //   // Create a reference to the file to delete
  //   // var fileRef = storage.refFromURL(props.url)
  //   var fileRef = storage.ref(`/verification/${props.name}`)

  //   // Delete the file
  //   fileRef.delete().then(() => {
  //     console.log("Deleted")
  //     working(false)
  //     setFile("")
  //     deleteDocumentField(table, id, "verification")
  //   }).catch((error) => {
  //     // Uh-oh, an error occurred!
  //     console.log(error)
  //   })
  // }

  const onRemove = (props) => new Promise((resolve, reject) => {
    console.log("onRemove", props)
    working(true)
    showLoader(true)

    // Create a reference to the file to delete
    // var fileRef = storage.refFromURL(props.url)
    var fileRef = ref(verificationRef, props.name)

    // Delete the file
    deleteObject(fileRef).then(() => {
      console.log("Deleted")
      working(false)
      setFile("")
      deleteDocumentField(table, id, fieldName)
      resolve(true)
    }).catch((error) => {
      console.log(error)
      reject(error)
      // Uh-oh, an error occurred!
    }).finally(() => {
      showLoader(false)
    })
  })

  const onChange = (props) => {
    // const onChange = ({ fileList: newFileList }) => {
    console.log("onChange", props)

    if (props.fileList.length === 0) {
      setFileList([])
      setFileName('')
    } else {
      setFileList([{ ...props.fileList[0], name: fileName }])
    }
    // if (props.event) {
    //   setProgress(props.event)
    // }
  }

  // const beforeUpload = (file) => {
  //   console.log("beforeUpload", file.name)
  //   const newFileName = `${new Date().valueOf()}-${file.name}`
  //   file.name = newFileName
  //   return file
  // }

  return (
    <Upload
      // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
      // listType="text"
      listType="picture"
      // listType="picture-card"
      defaultFileList={fileList}
      fileList={fileList}
      onChange={onChange}
      showUploadList={true}
      // onPreview={onPreview}
      customRequest={customRequest}
      onRemove={onRemove}
    // beforeUpload={beforeUpload}
    // accept="image/jpeg, image/png, image/gif"
    // maxCount={1}
    // progress={progress}
    >
      {fileList.length < 1 &&
        <Button icon={<UploadOutlined />}>Upload</Button>
      }
      {/* <div>
      {false ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div> */}
    </Upload>
  )
}

export default UploadFile
